import { render, staticRenderFns } from "./notificationTabCard.vue?vue&type=template&id=1a94260e&scoped=true&"
import script from "./notificationTabCard.vue?vue&type=script&lang=ts&"
export * from "./notificationTabCard.vue?vue&type=script&lang=ts&"
import style0 from "./notificationTabCard.vue?vue&type=style&index=0&id=1a94260e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a94260e",
  null
  
)

export default component.exports